import React from 'react';
import { GraduationCap, HeartHandshake, Home, FlaskConical } from 'lucide-react';

const audience = [
  { icon: GraduationCap, label: 'Professores' },
  { icon: HeartHandshake, label: 'Terapeutas' },
  { icon: Home, label: 'Famílias' },
  { icon: FlaskConical, label: 'Pesquisadores' },
];

const AudienceRow = () => {
  return (
    <section className="relative py-10 bg-muted/30">
      <div className="container mx-auto px-4">
        <p className="text-center font-body text-xs text-muted-foreground uppercase tracking-wider mb-6">
          Feito para toda a rede de apoio
        </p>
        <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-4">
          {audience.map((item) => (
            <div key={item.label} className="flex items-center gap-2 text-muted-foreground">
              <item.icon className="w-5 h-5" />
              <span className="text-base font-medium">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AudienceRow;
